import { errorHandler } from '../../../../services/middleware/api-middleware.js';
import { ROUTE_LOGIN } from '../../../router/constants.js';
import { showNotification as _showNotification } from '../../../notifications/ducks/notifications.js';
import {
	WE_SPIN_ERROR_NOTIFICATION_TITLE,
	WE_SPIN_SERVER_ERROR_BAD_REQUEST,
	WE_SPIN_SERVER_ERROR_INSUFFICIENT_FUNDS,
	WE_SPIN_SERVER_ERROR_UNAUTHORIZED_REQUEST,
	WE_SPIN_SERVER_ERROR_NOT_FOUND,
	WE_SPIN_SERVER_ERROR_NOT_LOGGED_IN,
	WE_SPIN_SERVER_ERROR_STREAM_ALREADY_RUNNING,
	WE_SPIN_SERVER_ERROR_GENERAL_ERROR
} from '../constants/we-spin-text-keys.js';
import { validateSession } from '~/components/authentication/ducks/index.js';

// All notifications defaults to open in sidebar
const showNotification = config =>
	_showNotification({
		titleKey: WE_SPIN_ERROR_NOTIFICATION_TITLE,
		openInSidebar: true,
		color: 'red',
		autoHide: true,
		...config
	});

export const defaultErrorActionCreator = () =>
	showNotification({
		messageKey: WE_SPIN_SERVER_ERROR_GENERAL_ERROR // 'Computers...'
	});

const routeToLogin = () => {
	window.location = ROUTE_LOGIN;
};

const showServerErrorMessage = (status, statusMessage, errorResponse) => async dispatch => {
	try {
		const error = await errorResponse.json();
		const { message, messageKey, titleKey, color } = error;
		dispatch(
			showNotification({
				...(message && { message }),
				...(messageKey && { messageKey }),
				...(titleKey && { titleKey }),
				...(color && { color })
			})
		);
	} catch (e) {
		dispatch(defaultErrorActionCreator());
	}
};

export const errorActionCreatorMap = {
	400: () =>
		showNotification({
			messageKey: WE_SPIN_SERVER_ERROR_BAD_REQUEST
		}),
	401: () => routeToLogin,
	402: () =>
		showNotification({
			messageKey: WE_SPIN_SERVER_ERROR_INSUFFICIENT_FUNDS
		}),
	403: () =>
		showNotification({
			messageKey: WE_SPIN_SERVER_ERROR_UNAUTHORIZED_REQUEST
		}),
	404: () =>
		showNotification({
			messageKey: WE_SPIN_SERVER_ERROR_NOT_FOUND
		}),
	405: () =>
		showNotification({
			messageKey: WE_SPIN_SERVER_ERROR_NOT_LOGGED_IN // 'Please login first'
		}),
	412: () => {
		return validateSession();
	},
	420: showServerErrorMessage,
	423: () =>
		showNotification({
			messageKey: WE_SPIN_SERVER_ERROR_STREAM_ALREADY_RUNNING // 'Stream already running'
		}),
	500: () =>
		showNotification({
			messageKey: WE_SPIN_SERVER_ERROR_GENERAL_ERROR // 'Server error'
		})
};

export const basicApiErrorHandler = errorHandler({
	errorActionCreatorMap,
	defaultErrorActionCreator
});
